import { render, staticRenderFns } from "./PublisherSetupTabBigDealCosts.vue?vue&type=template&id=0e7aa88c&scoped=true"
import script from "./PublisherSetupTabBigDealCosts.vue?vue&type=script&lang=js"
export * from "./PublisherSetupTabBigDealCosts.vue?vue&type=script&lang=js"
import style0 from "./PublisherSetupTabBigDealCosts.vue?vue&type=style&index=0&id=0e7aa88c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7aa88c",
  null
  
)

export default component.exports